import { Check } from "lucide-react";

const ORDER_STATUSES = [
  "placed",
  "confirmed",
  "processing",
  "shipped",
  "delivered",
] as const;

export const ProductOrderStatusProgress = ({ status }: { status: string }) => {
  const currentIndex = ORDER_STATUSES.indexOf(status as any);

  return (
    <div className="flex items-center justify-between gap-2">
      {ORDER_STATUSES.map((step, index) => {
        const isCompleted = index < currentIndex;
        const isActive = index === currentIndex;

        return (
          <div key={step} className="flex-1 flex items-center">
            <div className="flex flex-col items-center gap-2">
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full border text-sm font-medium
                  ${
                    isCompleted
                      ? "bg-green-500 border-green-500 text-white"
                      : isActive
                        ? "bg-blue-500 border-blue-500 text-white"
                        : "bg-gray-200 dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-500"
                  }`}
              >
                {isCompleted ? <Check size={16} /> : index + 1}
              </div>

              <span
                className={`text-xs capitalize
                  ${
                    isActive
                      ? "font-semibold text-blue-600 dark:text-blue-400"
                      : "text-gray-500"
                  }`}
              >
                {step}
              </span>
            </div>

            {index !== ORDER_STATUSES.length - 1 && (
              <div
                className={`flex-1 h-[2px] mx-2
                  ${
                    index < currentIndex
                      ? "bg-green-500"
                      : "bg-gray-300 dark:bg-gray-600"
                  }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
